interface LogoProps {
  showTagline?: boolean;
  fontSize?: number;
}

export default function Logo({ showTagline = false, fontSize = 48 }: LogoProps) {
  return (
    <div className="flex flex-col items-center">
      {/* TrueUp logo with Lobster font and left-to-right gradient */}
      <span
        style={{
          fontFamily: "'Lobster', cursive",
          fontSize: `${fontSize}px`,
          background: 'linear-gradient(to right, rgb(71, 159, 248), rgb(166, 43, 23))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        TrueUp
      </span>

      {showTagline && (
        <p className="text-sm text-gray-500 mt-1">
          Split restaurant bills with others
        </p>
      )}
    </div>
  );
}
